import type { ReactNode } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "./index";

/** Centered overlay dialog. */
export function Modal({
  onClose,
  children,
  width = "max-w-md",
}: {
  onClose: () => void;
  children: ReactNode;
  width?: string;
}) {
  return (
    <div
      className="fixed inset-0 z-[57] flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      <div className={`glass w-full ${width} p-5`} onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}

/** Confirmation dialog for destructive actions (single + bulk delete). */
export function ConfirmDialog({
  title = "Confirm",
  message,
  confirmLabel = "Confirm",
  pending,
  onConfirm,
  onClose,
  danger = true,
}: {
  title?: string;
  message: ReactNode;
  confirmLabel?: string;
  pending?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  danger?: boolean;
}) {
  return (
    <Modal onClose={onClose}>
      <div className="mb-2 flex items-center gap-2 text-accent">
        <AlertTriangle size={18} />
        <span className="font-semibold">{title}</span>
      </div>
      <div className="text-sm text-slate-300">{message}</div>
      <div className="mt-4 flex gap-2">
        <Button
          variant={danger ? "danger" : "primary"}
          onClick={onConfirm}
          disabled={pending}
          className="flex-1"
        >
          {pending ? "Working…" : confirmLabel}
        </Button>
        <Button variant="ghost" onClick={onClose}>Cancel</Button>
      </div>
    </Modal>
  );
}
